import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useJwtExpirationHandler from "./jwtExpirationHandler";
import { SHARED_TOKEN_QUERY_PARAM } from "./utils/sharedAccess";

const JwtExpirationHandlerComponent = () => {
  useJwtExpirationHandler();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const publicPaths = [
      "/login",
      "/forgotten-password",
      "/resetpassword",
      "/resetpassword/:token",
    ];
    const hasSharedToken = new URLSearchParams(location.search).has(
      SHARED_TOKEN_QUERY_PARAM
    );
    if (
      !token &&
      !publicPaths.includes(location.pathname) &&
      !hasSharedToken
    ) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  }, [navigate, location]);

  return null;
};

export default JwtExpirationHandlerComponent;
